module.exports = __webpack_public_path__ + "honor-01.jpg?a61029e54cfbb289b0e3632696feea35";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/honor-01.jpg
// module id = 179
// module chunks = 0